<template>
  <div
    id="aknVisualizer"
    class="aknVisualizer"
    :data-theme="theme"
    v-html="aknDOM"
    ref="aknDom"
  >
  </div>
</template>


<script>
  /* eslint-disable no-param-reassign */
  /* eslint-disable max-len */

  // import Vue from 'vue';
  import { createAkomando } from 'akomando';

  export default {
    name: 'AknVisualizer',
    props: [
      'theme',
      'aknString',
    ],
    beforeMount() {
      // create the akomando object
      const akomando = createAkomando({
        aknString: this.aknString,
      });
      this.akomando = akomando;

      // create the HTML dom
      const aknDom = this.akomando.getAkomaNtoso({
        serialize: 'HTMLString',
        addHtmlElement: false,
        addHeadElement: false,
        addBodyElement: false,
        addDataXPath: true,
        newLines: true,
      });
      this.aknDOM = aknDom.replace(/\s+/g, ' ');
      const aknMeta = this.akomando.getMeta({
        serialize: 'JSON',
        metaRoot: 'FRBRManifestation',
      });
      this.aknMeta = aknMeta;
    },
    mounted() {
      this.$refs.aknDom.querySelectorAll(
        'div.akn-ref',
      ).forEach((el) => {
        if (el.dataset.aknHref.includes('sentenza/corteCostituzionale') ||
            el.dataset.aknHref.includes('ordinanza/corteCostituzionale')) {
          const docUri = el.dataset.aknHref;
          const year = docUri.split('/')[6];
          const number = docUri.split('/')[7];
          if (el.dataset.aknHref.includes('sentenza')) {
            el.classList.add('sentenze-link');
            el.setAttribute('title', `Anteprima Sentenza n# ${number} del ${year} - (Clicca sul Link per Visualizzare la Sentenza completa)`);
            el.dataset.container = 'body';
            el.dataset.toggle = 'popover';
            el.dataset.trigger = 'hover';
            el.dataset.html = 'true';
            el.dataset.content = this.getLoader();
            el.addEventListener('click', () => {
              this.$router.push({
                path: `/pronuncia/sentenza/${year}/${number}`,
                // query: { docUri },
              });
            });
            /* el.addEventListener('mouseover', () => {
              this.setPopoverContent(number, year, docUri, el);
            }); */
          } else {
            el.classList.add('ordinanze-link');
            el.addEventListener('click', () => {
              this.$router.push({
                path: `/pronuncia/ordinanza/${year}/${number}`,
                // query: { docUri },
              });
            });
          }
        } else {
          const docUri = el.dataset.aknHref;
          const year = docUri.split('/')[6];
          const normalizedYear = (year.length === 4) ? year : year.split('-')[0];
          const number = docUri.split('/')[7];
          const article = (docUri.includes('#')) ? docUri.split('#')[1] : '';
          const normalizedArticle = (article === '') ? '' : `~art${article.split('_')[1]}`;
          const date = this.aknMeta[0].FRBRManifestation.FRBRdate[0].$.date;
          const urn = docUri.includes('cost') ?
            `urn:nir:stato:costituzione!vig=${date}${normalizedArticle}` :
            `urn:nir:stato:legge:${normalizedYear};${number}!vig=${date}${normalizedArticle}`;
          const link = `https://www.normattiva.it/uri-res/N2Ls?${urn}`;
          el.classList.add('legge-link');
          el.addEventListener('click', () => {
            window.open(link, '_blank');
          });
        }
      });
      // eslint-disable-next-line no-undef
      // $('.sentenze-link').popover();
    },
    methods: {
      findElements(identifier) {
        const elements = [];
        this.$el.querySelectorAll('*').forEach((el) => {
          const identifiers = Object.values(el.dataset);
          if (identifiers.includes(identifier)) {
            elements.push(el);
          }
        });
        return elements;
      },
      getLoader() {
        return `
          <div class="progress-spinner progress-spinner-active mx-auto text-center">
          <span class="sr-only">Caricamento...</span>
          </div>
        `;
      },
      /* async setPopoverContent(number, year, docUri, el) {
        if (!this.popovers[docUri]) {
          const separator = (process.env.NODE_ENV === 'development') ? '?' : '&';
          const url = `${Vue.prototype.$proxy}getDocumentInfo.xq${separator}year=${year}&number=${number}`;
          let documentInfo = await Vue.axios.get(url);
          documentInfo = documentInfo.data;
          const popoverContent = `
            <div class="it-list-wrapper">
              <ul class="it-list">
                <li>
                  <a href="#">
                    <div class="it-right-zone">
                      <span class="text">${documentInfo.presidente}<em>Presidente</em></span>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <div class="it-right-zone">
                      <span class="text">${documentInfo.relatore}<em>Relatore</em></span>
                    </div>
                  </a>
                </li>
                <li>
                  <a class="active" href="#">
                    <div class="it-right-zone">
                      <span class="text">${documentInfo.decisioneDate}<em>Data Decisione</em></span>
                    </div>
                  </a>
                </li>
                <li>
                  <a class="active" href="#">
                    <div class="it-right-zone">
                      <span class="text">${documentInfo.depositoDate}<em>Data Deposito</em></span>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          `;
          this.popovers[docUri] = popoverContent;
        }
        el.dataset.content = this.popovers[docUri];
        // eslint-disable-next-line no-undef
        $(el).popover('dispose');
        // eslint-disable-next-line no-undef
        $(el).popover();
        // eslint-disable-next-line no-undef
        $(el).popover('show');
        return this.popovers[docUri];
      }, */
    },
    data() {
      return {
        aknDOM: null,
        akomando: null,
        popovers: [],
      };
    },
  };
</script>

<style lang="scss" scoped>
  @import '../../assets/scss-templates/legal-docs-italia.act.scss';
</style>




// WEBPACK FOOTER //
// src/components/imports/AknVisualizer.vue